import React from 'react';
import { Alert, Button, FormGroup, Heading, HorizontalRule, Loader } from 'arag-ui-lib';
import { DOTS, ERROR, HEADING_2, INITIAL_NONE_OPTIONS, MEDIUM, PRIMARY, QUATERNARY, RIGHT } from '../../helpers/constants';
import { FORM_GROUP_VARIANTS } from '../../helpers/formGroupVariants';
import CONTENT_STRINGS from '../../helpers/contentStrings';
import { formatSolicitorOptionLabel } from '../../helpers/functions';
import { transferFirmOptions } from '../../helpers/transferCaseOptions';

const TransferApplicationBetweenSolicitorUsersModal = (props) => {
    const {
        SelectedApp,
        Store,
        SolicitorFirms,
        AgentsList,
        handleSolicitorFirmSelect,
        handleSolicitorSelect,
        _transferApplication,
        TransferApplicationBetweenSolicitorUsers,
    } = props;
    const policyProviderId = SelectedApp.aragProviderId ?? SelectedApp.aragProvider?.id ?? null;
    const firmOptions = [
        ...INITIAL_NONE_OPTIONS,
        ...transferFirmOptions(SolicitorFirms.lawsysFirms, SelectedApp.lawsysId, policyProviderId),
    ];

    const userOptions = [
        ...INITIAL_NONE_OPTIONS,
        ...AgentsList.allSolicitorUsers.map(u => ({ key: u.userId, label: u.username })),
    ];

    const hasArrayError = Store.badResponseTransferApplication && Array.isArray(Store.badResponseTransferApplication);
    const hasStringError = Store.badResponseTransferApplication && !Array.isArray(Store.badResponseTransferApplication);

    return (
        <div>
            <Heading
                variant={HEADING_2}
                title={CONTENT_STRINGS.CURRENT_SETTINGS}
                headingTestId={"transfer-case-current-settings-header"}
            />
            <FormGroup
                variant={FORM_GROUP_VARIANTS.PLAIN}
                label={CONTENT_STRINGS.SOLICITOR_FIRM}
                labelSize={"col-sm-4"}
                inputSize={"col-sm-8"}
                inputProps={{
                    id: 'current_solicitor_firm',
                    name: 'current_solicitor_firm',
                    label: SelectedApp.lawsysName || '',
                }}
                formGroupTestId={"transfer-case-current-settings-firm"}
            />
            <FormGroup
                variant={FORM_GROUP_VARIANTS.PLAIN}
                label={CONTENT_STRINGS.SOLICITOR_USER}
                labelSize={"col-sm-4"}
                inputSize={"col-sm-8"}
                inputProps={{
                    id: 'current_solicitor_user',
                    name: 'current_solicitor_user',
                    label: SelectedApp.agentName || '',
                }}
                formGroupTestId={"transfer-case-current-settings-user"}
            />
            <HorizontalRule />
            <Heading
                variant={HEADING_2}
                title={CONTENT_STRINGS.NEW_SETTINGS}
                headingTestId={"transfer-case-new-settings-header"}
            />
            <form className="form-horizontal">
                <FormGroup
                    variant={FORM_GROUP_VARIANTS.SEARCHABLE_LIST}
                    label={CONTENT_STRINGS.SOLICITOR_FIRM}
                    labelSize={"col-sm-4"}
                    inputSize={"col-sm-8"}
                    inputProps={{
                        instanceId: 'solicitor_firm_select',
                        name: 'solicitor_firm_select',
                        value: firmOptions.find(o => o.value === Store.solicitorFirmIdSelected) || null,
                        onChange: option => handleSolicitorFirmSelect(option ? option.value : ''),
                        options: firmOptions,
                        formatOptionLabel: formatSolicitorOptionLabel,
                    }}
                    formGroupTestId={"transfer-case-new-settings-firm"}
                />
                {
                    Store.solicitorFirmIdSelected !== '' 
                    ?
                        !AgentsList.fetching
                        ? 
                            <FormGroup
                                variant={FORM_GROUP_VARIANTS.SELECT}
                                label={CONTENT_STRINGS.SOLICITOR_USER}
                                labelSize={"col-sm-4"}
                                inputSize={"col-sm-8"}
                                inputProps={{
                                    name: 'solicitor_user_select',
                                    value: Store.solicitorFirmUserIdSelected || '',
                                    onChange: evt => handleSolicitorSelect(evt.target.value),
                                    options: userOptions,
                                }}
                                formGroupTestId={"transfer-case-new-settings-user"}
                            />
                        :
                            <Loader variant={DOTS} dotSize={MEDIUM} />
                    : 
                        null
                }
            </form>
            {
                hasArrayError
                ?
                    <div>
                        {Store.badResponseTransferApplication.map((msg, i) => (
                            <Alert key={i} variant={ERROR} label={msg} alertTestId={`transfer-case-error-${i}`} />
                        ))}
                        <FormGroup
                            variant={FORM_GROUP_VARIANTS.PLAIN}
                            label={CONTENT_STRINGS.TRANSFER_CONFIRM_MESSAGE}
                            labelSize={"col-sm-12"}
                            inputSize={"col-sm-12"}
                            inputProps={{
                                id: 'confirm_message',
                                name: 'confirm_message'
                            }}
                            formGroupTestId={"transfer-case-confirm-message"}
                        />
                        <div style={{display: 'flex', gap: '15px'}}>
                            <Button
                                label={CONTENT_STRINGS.YES}
                                variant={PRIMARY}
                                arrowDirection={RIGHT}
                                onClick={() => _transferApplication(true)}
                                buttonTestId={'transfer-case-yes'}
                            />
                            <Button
                                label={CONTENT_STRINGS.NO}
                                variant={QUATERNARY}
                                arrowDirection={RIGHT}
                                onClick={() => TransferApplicationBetweenSolicitorUsers('badResponseTransferApplication', '')}
                                buttonTestId={'transfer-case-no'}
                            />
                        </div>
                    </div>
                :
                    null
            }
            {
                !hasArrayError
                ?
                    hasStringError
                        ? <Alert variant={ERROR} label={Store.badResponseTransferApplication} />
                        : Store.transferringApplication
                            ? <Loader variant={DOTS} dotSize={MEDIUM} />
                            : <div style={{display: 'flex', gap: '15px'}}>
                                <Button
                                    label={CONTENT_STRINGS.CONFIRM}
                                    variant={PRIMARY}
                                    arrowDirection={RIGHT}
                                    onClick={() => _transferApplication(false)}
                                    buttonTestId={"transfer-case-confirm"}
                                />
                                <Button
                                    label={CONTENT_STRINGS.CANCEL}
                                    variant={QUATERNARY}
                                    arrowDirection={RIGHT}
                                    onClick={() => TransferApplicationBetweenSolicitorUsers('openTransferApplicationModal', false)}
                                    buttonTestId={"transfer-case-cancel"}
                                />
                            </div>
                :
                    null
            }
        </div>
    );
};

export default TransferApplicationBetweenSolicitorUsersModal;